export default __webpack_public_path__ + "static/media/landin-blockimg17.65551b99.png";